<template>
  <div class="product-paragraph" :class="customClass">
    <div class="paragraph-heading"><strong>
      <slot name="heading"/>
    </strong>
    </div>
    <div class="paragraph-content">
      <p>
        <slot name="value"/>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customClass: String
  },
};
</script>

<style scoped>

</style>
